// @flow
/** @jsx h */
import { PureComponent } from '../../helpers/pure-components'

import type {
  Poll,
  Result as ResultType,
  AuthConfig as AuthConfigType
} from '../../types'
import { prepareResult } from './helpers/prepareResult'

type RenderProps = {
  result?: ?ResultType,
  error?: ?Error,
  lastUpdatedTime: Date // timestamp
}

type Props = {
  clientId: number,
  poll: Poll,
  authConfig: AuthConfigType,
  render: (props: RenderProps) => any
}

type State = {
  result?: ?ResultType,
  error?: ?Error,
  lastUpdatedTime: Date // timestamp
}

export class WithResultState extends PureComponent<Props, State> {
  constructor (props: any) {
    super(props)
    this.state = {...this.getStateBasedOnProps(props)}
  }

  componentWillReceiveProps (nextProps: any) {
    this.setState({
      ...this.getStateBasedOnProps(nextProps)
    })
  }

  getStateBasedOnProps = (props: any) => {
    try {
      const { clientId, poll } = props

      // Prevent race conditions / setting result for previous poll
      if (clientId !== this.props.clientId || poll.id !== this.props.poll.id) {
        return {}
      }

      return {
        result: prepareResult(poll),
        error: null,
        lastUpdatedTime: new Date()
      }
    } catch (error) {
      return { error }
    }
  }

  render () {
    return this.props.render({ ...this.state })
  }
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/WithResultState.js